<template>
  <div
    style="background: linear-gradient(359.56deg, #070D0A -5.15%, #325343 58.51%, #264737 99.68%);"
    class="main-menu menu-fixed menu-accordion menu-shadow"
    :class="[
      { 'expanded': !isVerticalMenuCollapsed || (isVerticalMenuCollapsed && isMouseHovered) },
      skin === 'semi-dark' ? 'menu-dark' : 'menu-light'
    ]"
    @mouseenter="updateMouseHovered(true)"
    @mouseleave="updateMouseHovered(false)"
  >
    <!-- main menu header-->
    <div
      class="navbar-header expanded"
      style="margin-top:30px;"
    >
      <slot
        name="header"
      >
        <ul class="nav navbar-nav flex-row">

          <!-- Logo & Text -->
          <li class="nav-item mr-auto">
            <b-link
              v-if="userData.username === 'drr-iot'"
              to="/4g-total"
            >
              <span>
                <b-img
                  style="margin-left:-10px;"
                  src="@/assets/images/logo/logo_menu.svg"
                  alt="logo"
                />
              </span>
            </b-link>
            <b-link
              v-else
              to="/"
            >
              <span>
                <b-img
                  style="margin-left:-10px;"
                  src="@/assets/images/logo/logo_menu.svg"
                  alt="logo"
                />
              </span>
            </b-link>
          </li>

          <!-- Toggler Button -->
          <li class="nav-item nav-toggle">
            <b-link class="nav-link modern-nav-toggle">
              <feather-icon
                icon="XIcon"
                size="20"
                class="d-block d-xl-none d-md-none"
                @click="toggleVerticalMenuActive"
              />
              <feather-icon
                :icon="collapseTogglerIconFeather"
                size="20"
                class="d-none d-xl-none d-md-none collapse-toggle-icon"
                @click="toggleCollapsed"
              />
            </b-link>
          </li>
        </ul>
      </slot>
    </div>
    <!-- / main menu header-->

    <div style="text-align: center;">
      <!-- ชื่อหน่วยงาน -->
      <template>
        <div
          class="d-xl-none d-md-none user-nav"
          style="color: #ffffff; font-size: 18px;"
        >
          <b-button
            link-class="d-flex align-items-center"
            variant="link"
            @click="logout()"
          >
            <feather-icon
              class="icons"
              size="21"
              icon="LogOutIcon"
            />
            <span
              class="ml-1"
              style="color:white"
            >Logout</span>
          </b-button>
        </div>
      </template>
    </div>

    <!-- Shadow -->
    <div
      :class="{'d-block': shallShadowBottom}"
      class="shadow-bottom"
    />
    <!-- main menu content-->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="main-menu-content scroll-area"
      tagname="ul"
      @ps-scroll-y="evt => { shallShadowBottom = evt.srcElement.scrollTop > 0 }"
    >
      <br>
      <b-row>
        <b-col
          v-for="(item, index) in menu"
          :key="index"
          lg="12"
          md="12"
        >
          <app-collapse>
            <app-collapse-item
              :title="item.DeptGroupName"
              :style="{ 'background-color': dissapearColor }"
            >
              <div
                v-for="(item1, index1) in menu[index].DeptList"
                :key="index1"
              >
                <app-collapse-item
                  :title="item1.DeptName"
                  :style="{ 'background-color': dissapearColor }"
                >
                  <div
                    v-for="(item2, index2) in item1.Solution"
                    :key="index2"
                  >
                    <b-button
                      v-if="item2.TypeName === 'Counting' || item2.TypeName === 'CountAnalytic' || item2.TypeName === 'Count7Analytic'"
                      :class="{ active: item2.Link + index2 + 1 === activeButton }"
                      block
                      variant="outline"
                      :style="{'background-color': activeButton === item2.Link + index2 + 1 ? color : ''}"
                      :to="`/counting-sub?DeptID=${item2.Link}`"
                      @click="setActive(index2, item2.Link)"
                    >
                      <div class="d-flex justify-content-between flex-wrap">
                        <div>
                          <span style="color:#ffffff">{{ item2.TypeName }}</span>
                        </div>
                      </div>
                    </b-button>
                    <b-button
                      v-if="item2.TypeName === 'CCTV'"
                      :class="{ active: item2.Link + index2 + 1 === activeButton }"
                      block
                      variant="outline"
                      :style="{'background-color': activeButton === item2.Link + index2 + 1 ? color : ''}"
                      :to="`/cctv-sub?DeptID=${item2.Link}`"
                      @click="setActive(index2, item2.Link)"
                    >
                      <div class="d-flex justify-content-between flex-wrap">
                        <div>
                          <span style="color:#ffffff">{{ item2.TypeName }}</span>
                        </div>
                      </div>
                    </b-button>
                    <b-button
                      v-if="item2.TypeName === 'Lighting' && userData.username === 'drr-iot'"
                      :class="{ active: item2.Link + index2 + 1 === activeButton }"
                      block
                      variant="outline"
                      :style="{'background-color': activeButton === item2.Link + index2 + 1 ? color : ''}"
                      :to="`/4g-sub?DeptID=${item2.Link}`"
                      @click="setActive(index2, item2.Link)"
                    >
                      <div class="d-flex justify-content-between flex-wrap">
                        <div>
                          <span style="color:#ffffff">{{ item2.TypeName }}</span>
                        </div>
                      </div>
                    </b-button>
                    <b-button
                      v-if="item2.TypeName === 'Lighting' && userData.username !== 'drr-iot'"
                      :class="{ active: item2.Link + index2 + 1 === activeButton }"
                      block
                      variant="outline"
                      :style="{'background-color': activeButton === item2.Link + index2 + 1 ? color : ''}"
                      :to="`/lighting-sub?DeptID=${item2.Link}`"
                      @click="setActive(index2, item2.Link)"
                    >
                      <div class="d-flex justify-content-between flex-wrap">
                        <div>
                          <span style="color:#ffffff">{{ item2.TypeName }}</span>
                        </div>
                      </div>
                    </b-button>
                    <b-button
                      v-if="item2.TypeName === 'Reverse'"
                      :class="{ active: item2.Link + index2 + 1 === activeButton }"
                      block
                      variant="outline"
                      :style="{'background-color': activeButton === item2.Link + index2 + 1 ? color : ''}"
                      :to="`/reverse-sub?DeptID=${item2.Link}`"
                      @click="setActive(index2, item2.Link)"
                    >
                      <div class="d-flex justify-content-between flex-wrap">
                        <div>
                          <span style="color:#ffffff">{{ item2.TypeName }}</span>
                        </div>
                      </div>
                    </b-button>
                    <b-button
                      v-if="item2.TypeName === 'BridgeLighting'"
                      :class="{ active: item2.Link + index2 + 1 === activeButton }"
                      block
                      variant="outline"
                      :style="{'background-color': activeButton === item2.Link + index2 + 1 ? color : ''}"
                      :to="`/bridgelighting-sub?DeptID=${item2.Link}`"
                      @click="setActive(index2, item2.Link)"
                    >
                      <div class="d-flex justify-content-between flex-wrap">
                        <div>
                          <span style="color:#ffffff">{{ item2.TypeName }}</span>
                        </div>
                      </div>
                    </b-button>
                    <b-button
                      v-if="item2.TypeName === 'Bridge'"
                      :class="{ active: item2.Link + index2 + 1 === activeButton }"
                      block
                      variant="outline"
                      :style="{'background-color': activeButton === item2.Link + index2 + 1 ? color : ''}"
                      :to="`/bridge-sub?DeptID=${item2.Link}`"
                      @click="setActive(index2, item2.Link)"
                    >
                      <div class="d-flex justify-content-between flex-wrap">
                        <div>
                          <span style="color:#ffffff">{{ item2.TypeName }}</span>
                        </div>
                      </div>
                    </b-button>
                    <b-button
                      v-if="item2.TypeName === 'Analytic' || item2.TypeName === 'CountAnalytic' || item2.TypeName === 'Count7Analytic'"
                      :class="{ active: item2.Link + index2 + 1 === activeButton }"
                      block
                      variant="outline"
                      :style="{'background-color': activeButton === item2.Link + index2 + 1 ? color : ''}"
                      :to="`/analytic-sub?DeptID=${item2.Link}`"
                      @click="setActive(index2, item2.Link)"
                    >
                      <div class="d-flex justify-content-between flex-wrap">
                        <div>
                          <span style="color:#ffffff">{{ item2.TypeName }}</span>
                        </div>
                      </div>
                    </b-button>
                    <b-button
                      v-if="item2.TypeName === 'Motion'"
                      :class="{ active: item2.Link + index2 + 1 === activeButton }"
                      block
                      variant="outline"
                      :style="{'background-color': activeButton === item2.Link + index2 + 1 ? color : ''}"
                      to="#"
                      disabled
                      @click="setActive(index2, item2.Link)"
                    >
                      <div class="d-flex justify-content-between flex-wrap">
                        <div>
                          <span style="color:#ffffff">{{ item2.TypeName }}</span>
                        </div>
                      </div>
                    </b-button>
                    <b-button
                      v-if="item2.TypeName === 'SCADA'"
                      :class="{ active: item2.Link + index2 + 1 === activeButton }"
                      block
                      variant="outline"
                      :style="{'background-color': activeButton === item2.Link + index2 + 1 ? color : ''}"
                      to="#"
                      disabled
                      @click="setActive(index2, item2.Link)"
                    >
                      <div class="d-flex justify-content-between flex-wrap">
                        <div>
                          <span style="color:#ffffff">{{ item2.TypeName }}</span>
                        </div>
                      </div>
                    </b-button>
                    <b-button
                      v-if="item2.TypeName === 'Tunnel'"
                      :class="{ active: item2.Link + index2 + 1 === activeButton }"
                      block
                      variant="outline"
                      :style="{'background-color': activeButton === item2.Link + index2 + 1 ? color : ''}"
                      :to="`/tunnel-sub?DeptID=${item2.Link}`"
                      @click="setActive(index2, item2.Link)"
                    >
                      <div class="d-flex justify-content-between flex-wrap">
                        <div>
                          <span style="color:#ffffff">{{ item2.TypeName }}</span>
                        </div>
                      </div>
                    </b-button>
                    <b-button
                      v-if="item2.TypeName === 'CrossWalk'"
                      :class="{ active: item2.Link + index2 + 1 === activeButton }"
                      block
                      variant="outline"
                      :style="{'background-color': activeButton === item2.Link + index2 + 1 ? color : ''}"
                      :to="`/crosswalk-sub?DeptID=${item2.Link}`"
                      @click="setActive(index2, item2.Link)"
                    >
                      <div class="d-flex justify-content-between flex-wrap">
                        <div>
                          <span style="color:#ffffff">{{ item2.TypeName }}</span>
                        </div>
                      </div>
                    </b-button>
                    <b-button
                      v-if="item2.TypeName === 'TrafficSign'"
                      :class="{ active: item2.Link + index2 + 1 === activeButton }"
                      block
                      variant="outline"
                      :style="{'background-color': activeButton === item2.Link + index2 + 1 ? color : ''}"
                      :to="`/vms-sub?DeptID=${item2.Link}`"
                      @click="setActive(index2, item2.Link)"
                    >
                      <div class="d-flex justify-content-between flex-wrap">
                        <div>
                          <span style="color:#ffffff">VMS</span>
                        </div>
                      </div>
                    </b-button>
                    <b-button
                      v-if="item2.TypeName === 'Traffic'"
                      :class="{ active: item2.Link + index2 + 1 === activeButton }"
                      block
                      variant="outline"
                      :style="{'background-color': activeButton === item2.Link + index2 + 1 ? color : ''}"
                      :to="`/traffic-sub?DeptID=${item2.Link}`"
                      @click="setActive(index2, item2.Link)"
                    >
                      <div class="d-flex justify-content-between flex-wrap">
                        <div>
                          <span style="color:#ffffff">{{ item2.TypeName }}</span>
                        </div>
                      </div>
                    </b-button>
                    <b-button
                      v-if="item2.TypeName === 'Flooding'"
                      :class="{ active: item2.Link + index2 + 1 === activeButton }"
                      block
                      variant="outline"
                      :style="{'background-color': activeButton === item2.Link + index2 + 1 ? color : ''}"
                      :to="`/flooding-sub?DeptID=${item2.Link}`"
                      @click="setActive(index2, item2.Link)"
                    >
                      <div class="d-flex justify-content-between flex-wrap">
                        <div>
                          <span style="color:#ffffff">{{ item2.TypeName }}</span>
                        </div>
                      </div>
                    </b-button>
                    <b-button
                      v-if="item2.TypeName === 'WIM'"
                      :class="{ active: item2.Link + index2 + 1 === activeButton }"
                      block
                      variant="outline"
                      :style="{'background-color': activeButton === item2.Link + index2 + 1 ? color : ''}"
                      :to="`/wim-sub?DeptID=${item2.Link}`"
                      @click="setActive(index2, item2.Link)"
                    >
                      <div class="d-flex justify-content-between flex-wrap">
                        <div>
                          <span style="color:#ffffff">{{ item2.TypeName }}</span>
                        </div>
                      </div>
                    </b-button>
                  </div>
                </app-collapse-item>
              </div>
            </app-collapse-item>
          </app-collapse>
        </b-col>
      </b-row>
      <b-row v-if="userData.role === 'admin' && userData.groupname === 'drr'">
        <div>
          <b-button
            link-class="d-flex align-items-center"
            :to="'/user'"
            variant="outline"
            style="color:#ffffff"
          >
            <feather-icon
              size="20"
              icon="UserIcon"
              class="mr-50"
            />
            <span style="font-size: 16px;">จัดการผู้ใช้งาน</span>
          </b-button>
        </div>
      </b-row>

    </vue-perfect-scrollbar>
    <!-- /main menu content-->
  </div>
</template>

<script>
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {
  BLink, BImg, BRow, BCol, BButton,
} from 'bootstrap-vue'
import { provide, ref, computed } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'
import { $themeConfig } from '@themeConfig'
import axios from '@axios'
import navMenuItems from '@/navigation/vertical'
// import VerticalNavMenuItems from './components/vertical-nav-menu-items/VerticalNavMenuItems.vue'
import useVerticalNavMenu from './useVerticalNavMenu'

export default {
  components: {
    VuePerfectScrollbar,
    // VerticalNavMenuItems,
    BLink,
    BImg,
    BRow,
    BCol,
    BButton,
    AppCollapse,
    AppCollapseItem,
  },
  props: {
    isVerticalMenuActive: {
      type: Boolean,
      required: true,
    },
    toggleVerticalMenuActive: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      menu: [],
      dissapearColor: 'transparent',
      isActive: true,
      color: 'rgba(36, 36, 36, 0.7)',
      activeButton: 0,
      semControl: '',
    }
  },
  created() {
    this.getMenuITS()
  },
  mounted() {
    this.type = this.$route.query.type
  },
  methods: {
    logout() {
      this.$store
        .dispatch('auth/logout')
        .then(() => this.$router.push('/login'))
        .catch(err => console.log(err))
    },

    setActive(index, val) {
      this.activeButton = val + index + 1
    },
    getMenuITS() {
      axios
        .post('/getMenuITS', { department: this.userData.department, owner: this.userData.groupname, username: this.userData.username })
        .then(response => {
          // eslint-disable-next-line prefer-destructuring
          this.menu1 = response.data[0].json
          this.menu = JSON.parse(this.menu1)
          this.semControl = this.userData.department
          // this.menu.forEach(value => {
          //   this.menu.push(value.DeptGroupName)
          // })
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
  setup(props) {
    const {
      isMouseHovered,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      updateMouseHovered,
    } = useVerticalNavMenu(props)

    const { skin } = useAppConfig()

    // Shadow bottom is UI specific and can be removed by user => It's not in `useVerticalNavMenu`
    const shallShadowBottom = ref(false)

    provide('isMouseHovered', isMouseHovered)

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    const collapseTogglerIconFeather = computed(() => (collapseTogglerIcon.value === 'unpinned' ? 'CircleIcon' : 'DiscIcon'))

    // App Name
    const { appName, appLogoImage } = $themeConfig.app

    return {
      navMenuItems,
      perfectScrollbarSettings,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      isMouseHovered,
      updateMouseHovered,
      collapseTogglerIconFeather,

      // Shadow Bottom
      shallShadowBottom,

      // Skin
      skin,

      // App Name
      appName,
      appLogoImage,
    }
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/vertical-menu.scss";

.icons {
  color: #f8f8f8;
  // display: grid;
  // grid-gap: 0.5rem;
  // grid-template-columns: repeat(auto-fill, minmax(14rem, 1fr));
  // list-style: none;
  // margin: 0;
  // padding: 0;
}
</style>
